import { type FC, useMemo } from "react";
import { css, cx } from "@stubhub/broadway-foundation/css";
import { PLATFORM_ICON_MAP } from "src/website-apps/responsive/stubhub-performer/components/performer-social-media-links/constants";
import { SocialMediaLink } from "src/website-apps/responsive/stubhub-performer/components/performer-social-media-links/SocialMediaLinks";
import { usePerformerPageModelData } from "src/website-apps/responsive/stubhub-performer/hooks/usePerformerPageModelData";
import { LINKS_ORDER_V2 } from "src/website-apps/shared/constants/social-links";
import {
  dataHasSocialMediaLinks,
  usePerformerInfoCardData,
} from "src/website-apps/shared/hooks/usePerformerInfoCardData";

const socialMediaLinksContainer = css({
  display: "flex",
  alignItems: "center",
  columnGap: "[10px]",
  flexGrow: 1,
  justifyContent: "flex-start",
});

interface Props {
  /** additional class name for styling */
  className?: string;
}

/**
 * Social link icons to display on performer info card
 * TODO: clean up when portal deployed
 */
export const PerformerCardSocialLinks: FC<Props> = ({ className }) => {
  const model = usePerformerPageModelData();
  const { socialMediaLinks } = usePerformerInfoCardData();
  const performerName = model.categorySummary.categoryName;

  const socialMediaLinkComponents = useMemo(
    () =>
      LINKS_ORDER_V2.map((platform) => {
        if (!socialMediaLinks || !(platform in socialMediaLinks)) {
          return null;
        }

        return (
          <SocialMediaLink
            key={platform}
            url={socialMediaLinks[platform] ?? "#"}
            platform={platform}
            categoryName={performerName ?? ""}
            platformIcon={PLATFORM_ICON_MAP[platform]}
          />
        );
      }),
    [performerName, socialMediaLinks],
  );

  if (!dataHasSocialMediaLinks(socialMediaLinks)) {
    return null;
  }

  return <div className={cx(socialMediaLinksContainer, className)}>{socialMediaLinkComponents}</div>;
};
